import styled from 'styled-components';

const Form = styled.form`
  width: 500px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 5px;
`;

const Link = styled.button`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 15px;
  border: none;
  outline-style: none;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

export { Form, Link };
